import "./PendingVerificationPage.css";
import React from "react";
import FormImage from "../../Assets/images/login.png";
import PendingVerificationPageViewModel from "./PendingVerificationPageViewModel";
import Logout from "../../Controllers/Auth/Logout";

const PendingVerificationPage = () => {
  const [navigate] = PendingVerificationPageViewModel();
  return (
    <div className="main-wrapper pending-verification-body">
      <div className="pending-verification-wrapper">
        <div className="container">
          <div className="pending-verificationbox">
            <div className="pending-verification-left">
              <img className="img-fluid" src={FormImage} alt="Logo" />
            </div>
            <div className="pending-verification-right">
              <div className="pending-verification-right-wrap">
                <h1>Verification Pending</h1>
                <form>
                  <div className="form-group">
                    Your account is under verification, it will be verified
                    shortly.
                  </div>

                  <div className="form-group">
                    If your are in a hurry then you can always contact the
                    authorities.
                  </div>

                  <div className="form-group">
                    <button
                      type="button"
                      onClick={async () => {
                        const resp = await Logout();
                        if (resp === true) {
                          navigate("/login");
                        }
                      }}
                      className="btn btn-primary btn-block"
                    >
                      Logout
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingVerificationPage;
